export default {
  Clear: [
    "Clear skies, clear mind.",
    "Embrace the warmth of the day.",
    "Sunshine after the storm.",
    "Focus on a clear day.",
    "Path to a brighter future.",
    "Bask in clear day's energy.",
    "Nature's beauty revealed.",
    "Clear skies, full hearts.",
    "Inspired by clear sky.",
    "Motivation in clear day.",
  ],
  Snow: [
    "Snowflakes decorate the world.",
    "Find peace in falling snow.",
    "Appreciate beauty in simplicity.",
    "Snow brings magical silence.",
    "Snowflakes: tiny masterpieces fall.",
    "Nature's wonderland in snow.",
    "Worries float away with snow.",
    "Cozy up on snowy days.",
    "Warmth in snow's embrace.",
    "Quiet beauty in snow.",
  ],
  Rain: [
    "Raindrops soothe with melody.",
    "Wash away stress with rain.",
    "Rain cleanses and renews.",
    "Find harmony in rain.",
    "Raindrops: nature's confetti.",
    "Dance and let go in rain.",
    "Cozy up on rainy days.",
    "Growth comes with rain.",
    "Gray days lead to rainbows.",
    "Nature's music in rain.",
  ],
  Drizzle: [
    "Find beauty in gentle drizzle.",
    "Nature's soft touch: drizzle.",
    "Less is more in drizzle.",
    "Drizzle's impact: profound refreshment.",
    "Quiet solace in drizzle.",
    "Drizzle turns ordinary extraordinary.",
    "Charm in the quiet drizzle.",
    "Drizzle whispers nature's secrets.",
    "Beauty in drizzle's details.",
    "Soft influence of drizzle.",
  ],
  Clouds: [
    "Clouds hide silver linings.",
    "Drama in the sky's canvas.",
    "Let your light shine.",
    "Discover strength in clouds.",
    "Cloudy days: embrace spontaneity.",
    "Clouds: canvas for imagination.",
    "Clouds can't hide brightness.",
    "Sky's drama unfolds in clouds.",
    "Even cloudy days have clarity.",
    "Find sunshine beyond clouds.",
  ],
  Thunderstorm: [
    "Roar of thunder, inner strength.",
    "Thunderstorms: power within.",
    "Lightning illuminates inner courage.",
    "Fierce storms cleanse air.",
    "Calm within a thunderstorm.",
    "Thunderstorms: nature's fireworks.",
    "Dark storms bring bright lightning.",
    "Face challenges with resilience.",
    "Hold on; calm is near.",
    "Turbulence has a rhythm.",
  ],
  Mist: [
    "Mist: allure of mystery.",
    "Nature's veil: concealing, revealing.",
    "Mist's soft embrace brings calm.",
    "Mist adds magic to ordinary.",
    "Misty landscapes: subtle beauty.",
    "Mist: nature's poetry whispers.",
    "Clarity in mist's simplicity.",
    "Mist heightens senses, deepens experience.",
    "Not everything needs clarity.",
    "Imagination wanders in mist.",
  ],
  Smoke: [
    "Wisps of smoke: impermanence dance.",
    "Smoke adds mystique to atmosphere.",
    "Cherish present in smoke.",
    "Smoke's dance of change.",
    "Clarity in constant change.",
    "Smoke signals passage of time.",
    "Beauty in smoke's transformation.",
    "Smoke may linger, then dissipates.",
  ],
  Haze: [
    "Haze: world in soft focus.",
    "See through the haze.",
    "Hazy days, dreamy ways.",
    "Haze adds mystery to atmosphere.",
    "In haze, find beauty.",
    "Hazy dreams, clear intentions.",
    "Haze: nature's subtle filter.",
    "Haze softens harsh reality.",
    "Embrace the gentle haze.",
    "Through haze, see possibilities.",
  ],
  Dust: [
    "Dust in the wind: life's impermanence.",
    "Nature's dance: dust in sunlight.",
    "Dust settles, clarity emerges.",
    "In dust, find transient beauty.",
    "Dust: whispers of eternity.",
    "Dust dances, stories untold.",
    "Settle like dust, find clarity.",
    "Dust reveals hidden stories.",
    "Dust: transient, timeless tales.",
    "Dust settles, reveals essence.",
  ],
  Fog: [
    "Fog blankets, mysteries unfold.",
    "In fog's embrace, find serenity.",
    "Fog whispers tales of magic.",
    "Lost in fog, find yourself.",
    "Fog: nature's quiet drama.",
    "Fog veils, reveals enchantment.",
    "Foggy paths lead to discovery.",
    "Fog's mystery, nature's secret.",
    "Fog: softens, sharpens senses.",
    "Through fog, glimpse possibilities.",
  ],
  Sand: [
    "Sand whispers ancient stories.",
    "Footprints in sand: fleeting journeys.",
    "Sculpt dreams in the sand.",
    "Sand grains, time's witnesses.",
    "Sand dunes: nature's sculptures.",
    "In sand, echoes of time.",
    "Sand: where dreams settle.",
    "Dance with wind, like sand.",
    "Sand grains: time's poetry.",
    "Sand reveals time's artistry.",
  ],
  Ash: [
    "Ash: remnants of the past.",
    "From ash, rise anew.",
    "Ash settles, revealing rebirth.",
    "Ash: echoes of transformation.",
    "In ash, find resilience.",
    "Ash: phoenix's silent stage.",
    "Ash: past fuels future.",
    "From ash, bloom again.",
    "Ash: where endings begin.",
    "Ash whispers stories of resilience.",
  ],
  Squall: [
    "Squall's fury, nature's dance.",
    "Amidst squall, find calm.",
    "Squall's challenge, inner strength.",
    "Squall's roar, resilience echoes.",
    "Squall: storm's brief narrative.",
    "In squall, hear your heartbeat.",
    "Squall passes; calm remains.",
    "Squall's chaos births clarity.",
    "Squall's turbulence: find rhythm.",
    "In squall's challenge, discover strength.",
  ],
  Tornado: [
    "Tornado's dance, nature's fury.",
    "Amidst tornado, find center.",
    "Tornado's roar, inner calm.",
    "Tornado's chaos births clarity.",
    "Tornado's fury, strength within.",
    "In tornado's eye, find peace.",
    "Tornado: storm's fierce narrative.",
    "Tornado passes; calm remains.",
    "Tornado's challenge, resilience echoes.",
    "Tornado's turbulence: find inner rhythm.",
  ],
};
